/**
 * Tenant context utilities.
 * Calls current_tenant_id() RPC and caches the result.
 */

import { supabase } from '@/integrations/supabase/client';

let cachedTenantId: string | null | undefined = undefined;

/**
 * Returns the current user's tenant_id via the current_tenant_id() RPC.
 * Caches the result until clearTenantCache() is called.
 */
export async function getCurrentTenantId(): Promise<string | null> {
  if (cachedTenantId !== undefined) return cachedTenantId;

  try {
    const { data, error } = await supabase.rpc('current_tenant_id');
    if (error) {
      console.warn('Failed to fetch tenant id:', error.message);
      cachedTenantId = null;
    } else {
      cachedTenantId = data || null;
    }
  } catch {
    cachedTenantId = null;
  }

  return cachedTenantId;
}

/**
 * Clear cached tenant id (e.g. on sign out).
 */
export function clearTenantCache() {
  cachedTenantId = undefined;
}
